import { minMaxRandom } from "../Helpers/minMaxRandom";
import { ladderStatus } from "./ladderStatus";
import { resetClimb } from "./resetClimb";

export const ladderclimb = () => {
    //@ts-ignore
    const data = window.data_Click2Climb as HTMLElement;
    if (minMaxRandom(0, 100) > parseInt(data.dataset.ab2 || '75')) return resetClimb();
    const deactiveLevels = document.querySelectorAll('.ladder_level.l_deactive');
    const currentLevels = document.querySelectorAll('.ladder_level.l_current');
    if (deactiveLevels.length === 0 || deactiveLevels.length === 1) return;

    deactiveLevels.forEach((level, index) => {
        if(deactiveLevels.length - 1 === index + 1) {
            level.classList.add('l_current');
            ladderStatus(index);
            return;
        }
    })

    currentLevels.forEach((level, index) => {
        if(currentLevels.length - 1 === index) {
            level.classList.remove('l_current', 'l_deactive');
            level.classList.add('l_active',);
        }
    })
}